module.exports = {
      id: "icon-election-usage",
      viewBox: "0 0 110 110",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-election",
      toString: function () {
        return this.url;
      }
    }